






































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { CompanyDetailsModule } from '@/store/modules/companyDetails';
import LocationDto from '@/models/Locations/LocationDto';
import CreateLocationRequest from '@/models/Locations/CreateLocationRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import AddressTypes from '@/models/Shared/AddressTypes';
import GeoPoint from '@/models/Shared/GeoPoint';
import CountryIso from '@/lib/countryIso';
import AddressUtils from '@/lib/addressUtils';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import { LocationDetailsModule } from '@/store/modules/locationDetails';

@Component({
    name: 'CompanyLocationCreate'
})
export default class CompanyLocationCreate extends GiganautVueDialog {
 
  entity: LocationDto = new LocationDto();
  country: CountryIso = new CountryIso();
  addressSearchText = '';

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new LocationDto();
      this.country = new CountryIso();
      this.addressSearchText = '';
    }
  }

  get locationTypes() {
    return AgencySettingsModule.locationTypes;
  }

  get rateCards() {
    return CompanyDetailsModule.locationRateCards;
  }

  get isoCountries() {
    return AddressUtils.isoCountries();
  }

  get loading() {
    return CompanyDetailsModule.loadingDialog;
  }

  async getAddressData(addressData: any, placeData: any) {
      this.entity.buildingNameNumber = addressData.street_number ? addressData.street_number:'';
      this.entity.streetRoadBlock = addressData.route ? addressData.route:'';
      this.entity.locality = addressData.locality ? addressData.locality:'';
      //Pick out the postal town
      for (let index = 0; index < placeData.address_components.length; index++) {
        const element = placeData.address_components[index];
        if (element.types[0] === "postal_town"){
          this.entity.cityTown = element.long_name;
        }
        
      }
      //Pick out the country code
      for (let index = 0; index < placeData.address_components.length; index++) {
        const element = placeData.address_components[index];
        const isoCountriesLocal = this.isoCountries;
        if (element.types[0] === "country"){
          for (let countryIndex = 0; countryIndex < isoCountriesLocal.length; countryIndex++) {
            if (isoCountriesLocal[countryIndex].code === element.short_name) {
              this.country = isoCountriesLocal[countryIndex];
            }
          }
        }   
      }
      this.entity.stateProvinceRegion = addressData.administrative_area_level_2 ? addressData.administrative_area_level_2:'';
      this.entity.postZipCode = addressData.postal_code ? addressData.postal_code:'';
      this.entity.geometry.lat = addressData.latitude;
      this.entity.geometry.lng = addressData.longitude;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new CreateLocationRequest()
    request.registeredName = this.entity.brandName;
    request.brandName = this.entity.brandName;
    request.locationTypeId = this.entity.locationType.id;
    request.rateCardId = this.entity.rateCard.id;
    request.buildingNameNumber = this.entity.buildingNameNumber;
    request.streetRoadBlock = this.entity.streetRoadBlock;
    request.locality = this.entity.locality;
    request.cityTown = this.entity.cityTown;
    request.stateProvinceRegion = this.entity.stateProvinceRegion;
    request.postZipCode = this.entity.postZipCode;
    request.countryCode = this.country.code;
    request.geometry = new GeoPoint();
    request.geometry.lat = Number(this.entity.geometry.lat);
    request.geometry.lng = Number(this.entity.geometry.lng);
    
    await CompanyDetailsModule.createLocation(request)
    this.dialog = false;
  }
}
